import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.js%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../node_modules/@placekit/uikit/src/styles/fonts/Switzer-Variable.woff2%22,%22weight%22:%22100%20900%22,%22style%22:%22normal%22}],%22display%22:%22swap%22,%22adjustFontFallback%22:false}],%22variableName%22:%22switzer%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'switzer'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
